import Gnav from "./_gnav.es6";
import Modal from "./_modal.es6";
import Youtube from "./_youtube.es6";
import ProtectImg from "./_protectimg.es6";
import Share from "./_share.es6";
import ScrollFunc from "./_scrollfunc.es6";

export default class Main {
    constructor() {
        window.addEventListener("load", () => {
            document.body.classList.add("-load");
        });

        this.init();
    }

    init() {
        const gnav = new Gnav();
        const modal = new Modal();
        const youtube = new Youtube();
        const protectimg = new ProtectImg(); //画像保護＋右クリック阻止
        const share = new Share(); //lineシェアの空白対策
        const scrollfunc = new ScrollFunc();
    }
}
